import middleware from '@/middleware/index';
import authenticator from '@/utils/authenticator';
import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import $store from './store';
import Logout from '@/pages/TheLogout/index.vue';

Vue.use(Router);

const router = new Router(<any> {
  mode: 'history',
  base: '/',
  routes: [
    {
      name: 'logout',
      path: '/logout',
      component: Logout,
    },
    {
      name: 'signIn',
      path: '/signin',
      component: () => import(/* webpackChunkName: "signIn" */'./pages/TheSignIn/index.vue'),
      beforeEnter(to: RouteConfig, from: RouteConfig, next: (route?: any) => void): void {
        if (window.localStorage.getItem('accessToken')) {
          next({
            name: 'root',
          });
        }

        next();
      },
      children: [
        {
          path: 'install',
          name: 'installPwa',
          component: () => import(/* webpackChunkName: "installPwa" */'./pages/TheInstallPwa/index.vue'),
        },
      ],
    },
    {
      name: 'signInWithPinCode',
      path: '/signin/pincode',
      component: () => import(/* webpackChunkName: "signInWithPinCode" */'./pages/TheSignInWithPinCode/index.vue'),
      beforeEnter(to: RouteConfig, from: RouteConfig, next: (route?: any) => void): void {
        const state: any = $store.state;
        const user = state.user.user;
        const userToken = window.localStorage.getItem('accessToken');

        window.localStorage.removeItem('accessToken')

        if (from) {
          $store.dispatch('forceResetStore');
        }

        if (userToken !== null && user !== null) {
          authenticator.saveStaffAuthenticationCredentialsByStaffTokenAndId(
            {
              token: userToken,
              fullName: user.fullName,
              avatar: user.avatar.path,
              path: from.path
            },
            user.pinCode
          );
        }

        next();
      }
    },
    {
      name: 'requestRestorePassword',
      path: '/request-restore-password',
      component: () => import(/* webpackChunkName: "inviteStaff"*/'./pages/TheRequestRecoveryPassword/index.vue')
    },
    {
      name: 'restorePassword',
      path: '/restore/password/:token',
      component: () => import(/* webpackChunkName: "inviteStaff"*/'./pages/TheRecoveryPassword/index.vue')
    },
    {
      name: 'inviteStaff',
      path: '/invite/staff/:token',
      component: () => import(/* webpackChunkName: "inviteStaff"*/'./pages/TheInviteStaffPage/index.vue')
    },
    {
      name: 'install',
      path: '/install',
      component: () => import(/* webpackChunkName: "install" */'./pages/TheInstallPage/index.vue'),
    },
    {
      name: 'dashboard',
      path: '/dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */'./pages/TheDashboard/index.vue'),
      beforeEnter: guardRouteByAvailableSections
    },
    {
      name: 'root',
      path: '/',
      redirect: '/pos',
      beforeEnter(to: RouteConfig, from: RouteConfig, next: (route?: any) => void): void {
        if (to.name !== 'root') {
          const availableRouteName: string | undefined = getAvailableRouteNameByRoute(to);

          return next({
            name: availableRouteName,
            replace: true
          });
        }

        next();
      },
      component: () => import(/* webpackChunkName: "wrapper" */'./components/layout/TheAdminWrapper/index.vue'),
      children: [
        {
          name: 'pos',
          path: 'pos',
          component: () => import(/* webpackChunkName: "pos" */'./pages/ThePos/index.vue'),
          beforeEnter: guardRouteByAvailableSections
        },
        {
          name: 'kitchen',
          path: 'kitchen',
          component: () => import(/* webpackChunkName: "kitchen" */'./pages/TheKitchen/index.vue'),
          beforeEnter: guardRouteByAvailableSections
        },
        {
          name: 'menu',
          path: 'menu',
          component: () => import(/* webpackChunkName: "menu" */'./pages/TheMenu/index.vue'),
          beforeEnter: guardRouteByAvailableSections
        },
        {
          name: 'clients',
          path: 'clients/:id?',
          component: () => import(/* webpackChunkName: "clients" */'./pages/TheClients/index.vue'),
          beforeEnter: guardRouteByAvailableSections
          // children: [
          //   {
          //     name: 'clientView',
          //     path: ':id',
          //     component: () => import(/* webpackChunkName: "clients" */'./components/modals/clients/ClientViewModal/TheDesktop.vue'),
          //     beforeEnter: guardRouteByAvailableSections
          //   }
          // ]
        },
        {
          name: 'storehouse',
          path: '/storehouse',
          component: () => import(/* webpackChunkName: "storehouse" */'./pages/TheStorehouse/index.vue'),
          beforeEnter: guardRouteByAvailableSections
        },
        {
          name: 'settings',
          path: 'settings',
          component: () => import(/* webpackChunkName: "settings" */'./pages/TheSettings/index.vue'),
          redirect: '/settings/place',
          beforeEnter: guardRouteByAvailableSections,
          children: [
            {
              name: 'takeAwaySettings',
              path: 'takeAway',
              component: () => import(/* webpackChunkName: "takeAwaySettings" */'./pages/TheSettings/TheTakeAwaySettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'reservationSettings',
              path: 'reservation',
              component: () => import(/* webpackChunkName: "reservationSettings" */'./pages/TheSettings/TheReservationSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'devicesSettings',
              path: 'devices',
              component: () => import(/* webpackChunkName: "devicesSettings" */'./pages/TheSettings/TheDevicesSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'staffSettings',
              path: 'staff',
              component: () => import(/* webpackChunkName: "staffSettings" */'./pages/TheSettings/TheStaffSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'placeSettings',
              path: 'place',
              component: () => import(/* webpackChunkName: "placeSettings" */'./pages/TheSettings/ThePlaceSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'kitchenSettings',
              path: 'kitchen',
              component: () => import(/* webpackChunkName: "kitchenSettings" */'./pages/TheSettings/TheKitchenSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'promotionsAndDiscountsSettings',
              path: 'promotions',
              component: () => import(/* webpackChunkName: "promotionsAndDiscountsSettings" */'./pages/TheSettings/ThePromotionsSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'appsSettings',
              path: 'apps',
              component: () => import(/* webpackChunkName: "appsSettings" */'./pages/TheSettings/TheAppsSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'appearanceSettings',
              path: 'appearance',
              component: () => import(/* webpackChunkName: "appearanceSettings" */'./pages/TheSettings/TheAppearanceSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'inprogressSettings',
              path: 'inprogress',
              component: () => import(/* webpackChunkName: "inprogressSettings" */'./pages/TheSettings/TheInprogressSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'pwaSettings',
              path: 'pwa',
              component: () => import(/* webpackChunkName: "pwaSettings" */'./pages/TheSettings/ThePwaSettings/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            },
            {
              name: 'remarketingPromotions',
              path: 'new_promotions',
              component: () => import(/* webpackChunkName: "remarketingPromotions" */'./pages/TheSettings/TheRemarketingPromotions/index.vue'),
              beforeEnter: guardRouteByAvailableSections
            }
          ]
        }
      ]
    },
    {
      path: '/*',
      name: 'notFound',
      component: () => import(/* webpackChunkName: "notFound" */'./pages/TheNotFound/index.vue')
    }
  ]
});

router.beforeEach(middleware);

export default router;

function guardRouteByAvailableSections(to: RouteConfig, from: RouteConfig, next: (route?: any) => void): void {
  if (!getIsAvailableRoute(to)) {
    return next({
      name: 'notFound',
      replace: true
    });
  }

  next();
}

function getAvailableRouteNameByRoute(to: RouteConfig): string | undefined {
  if (to.name !== 'root') {
    const state: any = $store.state;
    const availableSections: { [key: string]: boolean } = state.user.user.availableSections;

    if (!getIsAvailableRoute(to)) {
      for (let key in availableSections) {
        if (availableSections.hasOwnProperty(key) && availableSections[key]) {
          return key;
        }
      }

      return 'notFound';
    }
  }
}

function getIsAvailableRoute(to: RouteConfig): boolean {
  const state: any = $store.state;
  const availableSections: { [key: string]: boolean } = state.user.user.availableSections;
  const toRouteName: string = getRouteName(to);

  return availableSections[toRouteName] || true;
}

function getRouteName(to: RouteConfig): string {
  const toRouteName = to.name || '';

  if (toRouteName.toLocaleLowerCase().includes('settings')) {
    return 'settings';
  }

  return toRouteName;
}
